/* eslint-disable consistent-return */
import generatePrimitiveColors from './util/primitiveColors'

// eslint-disable-next-line import/prefer-default-export
export const designTokensHelper = (theme) => {
  const systemTheme = 'light'
  if (!theme) {
    return
  }
  const { brandColors } = theme
  const primitives = generatePrimitiveColors(systemTheme)
  return {
    color: {
      primitives: {
        ...primitives,
      },
      house: {
        fill: {
          page: primitives.neutral[0],
          overlay: systemTheme === 'light' ? primitives.black.alpha[30] : primitives.white.alpha[20],
          onSurface: primitives.neutral[0],
          primary: systemTheme === 'light' ? 'rgba(0, 0, 0, 0)' : 'rgba(255, 255, 255, 0)',
          secondary: systemTheme === 'light' ? primitives.neutral[100] : primitives.neutral[200],
          error: primitives.red[100],
          success: primitives.green[100],
          button: {
            primary: primitives.neutral[500],
            disabled: primitives.neutral[200],
          },
          fieldset: {
            menuHover: primitives.neutral[200],
            disabled: primitives.neutral[200],
          },
        },
        border: {
          primary: primitives.neutral[300],
          secondary: systemTheme === 'light' ? primitives.neutral[200] : primitives.neutral[300],
          secondary2: systemTheme === 'light' ? primitives.neutral[200] : primitives.neutral[300],
          error: primitives.red[500],
          success: primitives.green[500],
          button: {
            secondary: primitives.neutral[500],
          },
        },
        text: {
          onSurface: primitives.neutral[0],
          body: primitives.neutral[400],
          primary: primitives.neutral[400],
          secondary: primitives.neutral[300],
          tertiary: primitives.neutral[200],
          disabled: primitives.neutral[300],
          error: primitives.red[500],
          success: primitives.green[500],
        },
        utility: {
          onSurface: primitives.neutral[0],
          primary: primitives.neutral[400],
          secondary: primitives.neutral[300],
        },
      },
      brand: {
        core: {
          pageFill: brandColors?.core?.pageFill?.[systemTheme],
          primary: brandColors?.core?.primary?.[systemTheme],
          onSurface: brandColors?.core?.onSurface?.[systemTheme],
        },
        foundation: {
          fill: {
            accent: brandColors?.foundation?.fill?.accent?.[systemTheme],
            primary: brandColors?.foundation?.fill?.primary?.[systemTheme],
            secondary: brandColors?.foundation?.fill?.secondary?.[systemTheme],
            error: brandColors?.foundation?.fill?.error?.[systemTheme],
            success: brandColors?.foundation?.fill?.success?.[systemTheme],
          },
          border: {
            accent: brandColors?.foundation?.border?.accent?.[systemTheme],
            primary: brandColors?.foundation?.border?.primary?.[systemTheme],
            secondary: brandColors?.foundation?.border?.secondary?.[systemTheme],
            error: brandColors?.foundation?.border?.error?.[systemTheme],
            success: brandColors?.foundation?.border?.success?.[systemTheme],
          },
        },
        text: {
          body: brandColors?.text?.body?.[systemTheme],
          primary: brandColors?.text?.primary?.[systemTheme],
          secondary: brandColors?.text?.secondary?.[systemTheme],
          onSurface: brandColors?.text?.onSurface?.[systemTheme],
          error: brandColors?.text?.error?.[systemTheme],
          success: brandColors?.text?.success?.[systemTheme],
        },
        utility: {
          primary: brandColors?.utility?.primary?.[systemTheme],
          secondary: brandColors?.utility?.secondary?.[systemTheme],
        },
      },
    },
  }
}
